module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Opening Movement: December 3, 1994")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('h3', {
    staticClass: "ch-sub"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Huntsville, Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He knew prison tradition, and he damn well knew it was custom for guards to stand at the gate and shake his hand as he left. Nearly thirty years in this place, hardly a breath of air or a look at the clean blue sky, and the only men waiting were the ones who had to be there. The two mangy bastards couldn’t even crack a smile for him. They were wearing silvery sunglasses today, and he saw himself twisted like a hunchback in reflection, his hair gone thin and gray. The damn Salvation Army suit hung on him like a secondhand sack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, boys, any last words of advice?” He pulled in a deep breath of the morning. Pure free air, scented with pine and grass; he caught the stale smell of prison and knew he carried the reek of despair in his clothes. The guards’ mirrored glasses shifted away from him and reflected the rising sun, the cool green tree line, the dull gray gun towers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And they said nothing at all.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("The outer gate squealed as it ran back on its tracks, like the jaws of hell pried open. He took a firmer ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("grip on the secondhand duffel bag and took a step forward, coming even with the guards. They shifted away like he was tubercular.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want some advice, pops? Stay out,” one of them said, he didn’t know which. He backed up and grinned at the both of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Surely do intend to.” He tipped an imaginary hat to them with callused hands. “Ya’ll have a nice day, boys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They stood rock-still as he strolled out the gate, out into the cold Texas morning. Out into freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Custer Grady was a free man again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He walked to the road, where the bus would presently wind its way around the curve and squeal to a stop for him, where the bus driver would look at him like a rotten worm in a fresh apple but would take him on into town anyway. He had the bus fare in his pocket, jingling like Christmas bells. After that—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After that, he had things to see to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sat down on the rough concrete bench and scuffed his shoes in the winter-blasted grass. In the distance, at the foot the gentle hill, a freeway sliced through the trees, and cars moved along in a shimmering blur. Freeway, now there was a word. He was a free man on the freeway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir,” he continued. The blunt silver nose of the bus edged around the curve and blundered toward him. “It’ll all be over soon.”")]), _vm._v(" "), _c('h3', {
    staticClass: "ch-sub1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Midland, Texas, same day")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Abby’s first thought of the day was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’m going to be sick")]), _vm._v(", and then she was, violently, into the trash can ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("she’d put next to her bed. It was a wide-mouthed trash can with two plastic liners, just to be sure.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Preparation paid off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the spasms were over she lay back and folded her hands over her rolling stomach and tried calming exercises. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Start with your toes")]), _vm._v(". Her toes had nothing to do with it, it was her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hands")]), _vm._v(", it was her goddamn "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hands. Are your toes relaxed?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course they weren’t. She went on to her feet. By the time she’d reached her thighs she was tired of the whole thing and sat up. Sitting up was bad. Her stomach lurched, and she had to think about emptying the trash can. Better to do it now, while her stomach was still in shock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bed had been warm—not comforting, exactly, but warm. The floor was another story, chill sliding across the wood like invisible snakes to writhe around her ankles. She hip-hopped to the many-times-painted-over closet door and banged it back. Piles of shoes, none of them new. She dug until she’d located one frazzled gray slipper, shoved her toes in, and kept digging. The other slipper lurked under a discarded box of last Christmas’s chocolate-covered cherries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gross,” she said gloomily. She rattled it. Full. It was probably a roach farm. She shuffled back to the trash can and dropped the box in from an arm’s length away, got down eye level with the rim to pull the liners up and twist them shut. It was the ambush approach to cleaning.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("The plastic bags gurgled like her stomach as she ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("quick-shuffled down the dark hallway toward the kitchen, holding the bags as far as possible.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maria?” she yelled. No answer. Her roommate knew her too well to be around for these little waste disposal problems. Abby fumbled one-handed in the junk drawer and found a plastic twistee to secure the bags, then shoved the whole thing in a bigger green trash can with peeling biohazard stickers and smiley faces. She slammed the pantry door on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mission accomplished.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maria had taped a big note to the refrigerator door that said "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GOOD LUCK PUKEY")]), _vm._v(", which almost made her smile. She opened the box and found a half-empty carton of chocolate milk. One glass left semi-clean beside the sink; she rinsed it out and poured sweet relief until the carton went dry. The first mouthful went down hard, but the second was easier. She drank until the glass was empty and rinsed it clean with a few halfhearted swipes of lemony detergent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carlton’s doggie bowl in the corner was full, which was a blessing; opening a can of dog food would have been the end of the world. And where the hell was Carlton, anyway? He usually would have been whining at her door by seven, and it must be later than that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby squinted out at the world through a slit in the blinds and saw a blank concrete walkway along with some sprigs of half-dead grass that winter hadn’t managed yet to kill. Midland, Texas’s ideas of landscaping. Maybe Maria had taken the dog out for a run.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("As she turned she saw the clock hanging crookedly ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("on the kitchen wall. 9:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Five hours!")]), _vm._v(" the beast in the back of her brain screamed. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Five hours! Five hours!")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shut up,” she sighed. She negotiated through the maze of rickety tables and secondhand furniture—plaid earth tones and one enormous pastel chair Maria had found at some garage sale—and found an uncluttered spot on the couch. She curled up in a comforting ball and searched for the TV remote one handed. She found it stuffed in the couch cushions and clicked it three times before the TV came awake, as sluggish as she was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maria had left her another note, this one in big black letters sitting on top of the littered coffee table. It said, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GO GET YOUR MUSIC NOW!!! ")]), _vm._v(" and the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOW!!!")]), _vm._v(" was underlined three times. Abby groaned and hugged a pillow close and tried to go back to sleep, but Maria’s "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOW!!!")]), _vm._v(" and the beast’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Five hours! Five hours!")]), _vm._v(" ruined it. She shuffled back down the dim wooden hallway to her bedroom, gathered up her black concert folder—the expensive leather one Benny had given her last Christmas—and her instrument cases. She dumped them by the front door, right where she’d trip over them if she tried to leave without them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Damn, it was cold on the floor. She frowned as she thought about the delicate wood of the clarinets, and set the cases on top of a table where the central heating could reach them. Then she flopped on the couch again and curled up to let the chocolate milk work its magic.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("She’d left the nasty plastic sack full of stomach contents in the pantry. The thought brought her bolt upright and scrambling; she dug a robe out from ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("under a pile of pillows, found her boots and coat, and retrieved the bag. She hurried outside, across the parking lot to the rusted gap-topped Dumpster, and tossed the bag in, retreating even before she heard it plop wetly inside.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The joys of housekeeping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back in the warmth of the apartment, she drifted off on the couch to the buzz of the TV and the beast screaming "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Four and a half hours! Four and a half hours!")]), _vm._v(" and came awake in a panicked fog, flailing, pillows flying like frightened chickens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Somebody knocked on the door. She stumbled over Maria’s cherished throw rug and cursed. Her music folder slid under her foot like a skate and escaped into the gloom. She had the door halfway open before she remembered that she was wearing thin pajamas with a button missing at the top.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then she staggered back, arms full of struggling dog.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Carlton?” She blinked away confusion and pushed the dog far enough away to see Carlton’s grinning long-nosed face. “Damn, boy, where did you come—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Words failed as she saw the man standing in her doorway. He was wearing blue jeans and a plaid work shirt and a straw cowboy hat. A narrow, intense, guarded face. Large dark eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi,” she said lamely, and tried to get Carlton to lay off the slurping. “Uh, hi.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("“Ma’am,” he said, giving her a nod as he took his hat off. She realized that wrestling with Carlton had popped another button on her top, which gave him ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("an unobstructed view all the way to her navel. She clutched at the fabric one-handed and got Carlton under control. “I guess that’d be your dog, then.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t know he was gone,” she blurted. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Responsible pet ownership strikes again")]), _vm._v(". “I thought, uh, my roommate had him. She takes him out for runs, sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The stranger was staring at the floor to avoid looking at her cleavage—no, he was looking at Carlton’s feet. She glanced down and saw that there were bandages on the dog’s paws, too clumsy to have been vet-done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Found him at my mom’s door before sunrise this morning. Looked at his tag and figured I’d bring him back, since I was coming to town anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What the hell happened to his feet?” She hung halfway between scared and mad, appalled that she hadn’t been worried about the mutt, hadn’t even thought much about him in the press of her own selfishness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was at my mom’s house,” the man explained again, slowly. “In Fall Creek.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carlton thumped his fluffy tail against Abby’s leg hard enough to bruise. She scratched his head and he licked her fingers enthusiastically.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fall Creek. Thirty miles that way.” He pointed vaguely toward the southwest. “Kind of a long way for a dog to run. He been missing all night?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Thirty miles? She looked at Carlton for confirmation, but he thumped his tail on her and walked away, sniffing the furniture to make sure she’d taken ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("no other dog before him. “Uh, no, I thought he was here last night—I was sick—look, would you like to come in?”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He nodded. She backed up to let him in and watched Carlton rub against his leg. It looked okay. Bad guys couldn’t make friends with dogs, could they? Not big dogs. Not big "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("stupid")]), _vm._v(" dogs like Carlton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now that he was standing in her home and blocking the door, she had no idea what to say to him. He wasn’t much bigger than she was, compact and wiry. He looked strong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Coffee?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took his hat off, turned it in his hands, and nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Coffee. Uh—I’ll just be a second.” She flip-flopped at high speed to her room, pawed through an untidy pile of clean clothes, and found Maria’s thick blue fleece robe. Perfect. She tied it tight on her way back down to the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No trouble. Least I can do when you bring me back the mutt.” Maria kept instant coffee somewhere. Sugar canister? No, that was full of baking soda. She hit the jackpot in the tea canister and spooned black crystals into chipped blue mugs. “I’m out of milk. Black okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine.” He’d stepped around the stucco divider to watch her. Didn’t his face do any expressions? “Your name’s Abby, right? Abby Rhodes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom loved the Beatles.” The explanation was reflex, but he smiled. “Know what makes me feel really old? People ten years younger than you don’t think my name’s funny at all. So you’re—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“John Lee Jordan.” He stuck out a hand. She caught a glimpse of scars crisscrossing his palm, felt the ridges press against her skin as they shook. He had cuts on the back of his hand, too. A few looked recent.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Carlton didn’t scratch you, did he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He saw her looking at the cuts and shook his head. “He was just fine. A real good dog.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Lee Jordan was not a talker. She waited for the microwave to do its thing and jittered her slipper nervously. He turned his hat in his hands and set it down on the countertop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The microwave dinged. As she took steaming cups out of it, he said, “You ever live in Fall Creek?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never been there.” She felt something when he said the name, though. A surge of adrenaline. Fear. She stirred both cups of coffee until they were the correct brown sludge and handed one over to him. “Why do you ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sometimes when dogs run away they go to old homes, places they remember.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can definitely say he never lived in Fall Creek.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He kept staring at her face like he knew her. She wanted to stare back but didn’t dare; she blew on her coffee instead, using the steam like a modesty veil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, maybe you know my mother,” he said. “Pearl Jordan.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("If she hadn’t been holding onto the counter she might have fallen; her knees went weak and the world went gray and she heard a voice say, from a great distance, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pearl? My Lord, Pearl")]), _vm._v(", and the next thing she knew her heart was hammering hard ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("enough to hurt and John Lee’s hands were guiding her to the big pastel chair and he did have another expression, this one worried. She felt dizzy again and put her head between her knees and gasped for breath. Carlton, ever helpful, tried to lick her face since it was within reach. John Lee nudged him firmly back.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry,” she mumbled. His hands massaged her shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deep breaths. Keep your head down.” He pinched tension out of her neck. “Abby? Can you hear me? You want a doctor?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.” She sat up and leaned back. Her shoulders felt hot where he’d rubbed them. He backed up a couple of steps, still watching her. “I—I’ve got this thing. This, uh, nausea thing. It’ll go away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked guarded. She reviewed the sentence in her head and said, “Oh, no, it’s not morning sickness or anything. It’s performance anxiety.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He cocked his head like she’d said something in a foreign language. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, God")]), _vm._v(", she thought, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that didn’t sound too good at all")]), _vm._v(". She rushed on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See, I’m a musician, and I get these shakes before I play. It’s nothing, really. I’m okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The beast in the back of her brain, taking no notice at all of Carlton’s disappearance or rescue or a strange man sitting in her living room, announced that she had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("four hours")]), _vm._v(" until curtain, and expressed some intention to throw up the chocolate milk she’d appeased it with.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("“Whatever you say.” John Lee reclaimed his coffee cup from the kitchen counter and leaned against the ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("counter, sipping and watching. “So, you don’t know my mother? Pearl Jordan?”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The name still stung like a wasp. “Never met her,” Abby said sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then maybe old Carlton there just wanted a long midnight run. You’ll probably want to get those paws seen to by a vet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now that the excitement of the reunion was over, Carlton was definitely limping as he surveyed his domain; when Abby snapped her fingers he hobbled over and draped himself at her feet, panting and pleased. She dug her fingers into his thick warm coat and scratched his neck under the collar, which sent him into spasms of doggy ecstasy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mutt,” she murmured. “What the hell were you doing, running all over creation? Chasing a girl?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t get him from a pound, did you? Maybe found him?” John Lee was still obsessing over his dog-returns-home theory. She wondered whether she was going to have to sign something to convince him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think he was going back to a previous owner?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I know. I’ve had him since he was small enough to fit in one hand, haven’t I, baby?” She got up, tested her balance and found it more or less adequate, and took the coffee cup from him on the way to the door. “Look, Mr. Jordan, I can’t thank you enough for what you did for Carlton. It was really sweet. I wish I could pay you but—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("She gestured around at the secondhand apartment, ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("as if that was all the explanation she needed. He gave her one more look, the intense kind, put his hat on, and went out the door she held open for him. His eyes went the color of dark beer in the sun.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t need any money, Miz Rhodes. But thanks for the coffee. Carlton, you be a good boy, hear?” He held out his hand and the dog licked it one more time, politely. As Abby started to shut the door, John Lee put one hand flat on it and stopped her. “What kind of music?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Performance anxiety. What kind of music?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Classical,” she said. “Clarinet. I’m playing at the Civic Auditorium at two-thirty today. Mozart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mozart,” he repeated, and smiled. It was startling how much of a difference it made in his face, his eyes. “I always liked Mozart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She found herself watching him as he walked away and was entertaining a cautious, half-hazy fantasy when the beast in the back of her brain screamed, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Four hours! Four hours! Four hours, you dumb talentless bitch!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, perfect,” she breathed, and eased the door shut. “He likes Mozart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("She got mascara in her eye, cursed, and dabbed at the tears with a scrap of tissue. Her hands were shaking. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maybe I scratched my cornea. Maybe I can’t go on")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Any port in a storm. She blinked against the burn and tattooed black dots from her eyelashes to her eyelids. As she dabbed them with the damp tissue, she took off half the eye shadow.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Another typical performance.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Outside the bathroom window, a car horn honked part of Beethoven’s Fifth. Great. She abandoned her makeup and put her glasses back on. Deep breaths, right from the diaphragm. Her black dress, a relic from her college recital days, looked fine. She’d twisted her hair back into a motherly-looking bun. No necklace or bracelet. Only one ring, a little jade circle from her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The uniform was correct. She left the bathroom, gathered up her music folder from the floor, checked to be sure everything was there. It was. Purse. It was hiding under a chair. Her instruments—A, B-flat, E-flat—were all bundled together in one unwieldy carrying case. She checked the latch to make sure it wouldn’t open when she picked it up and spill a fortune all over the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The door vibrated under a staccato of knocks. Carlton limped into the living room and whoofed half heartedly. Abby opened the door and squinted through burning eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benina Wright lit another cigarette from the butt of an old one, blew a thick lungful of smoke into the air, and said, “Land shark. You ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She crouched down to pat Carlton’s head. Abby stared at her, speechless with amazement. When she’d gotten control of her tongue again, she sputtered, “What happened to your hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny looked up, tossing tiny braids over her shoulders like snakes. Black and white braids, the Bride of Frankenstein gone reggae. She looked like an industrial accident.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Yesterday she’d been a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("redhead")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You like it? Black and white,” she pointed out, rubbing Carlton’s head. “Very formal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no sense at all in pointing out to Benny that she was supposed to be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("invisible")]), _vm._v(" as an accompanist at a recital. Benny had never been invisible in her life. Today, she wore skin-tight black tuxedo pants with a glittery silver stripe down the side, stiletto heels, and a spangled vest that featured Bugs Bunny and Daffy Duck. And the braids, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby gave up and turned away to take inventory again, wondering what she was missing, wondering if it would even matter. No one would notice her, with Benny’s hair onstage. Her instrument case was where she’d left it. Her purse—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t like the vest.” Benny’s voice had gone small and quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby sighed, closed her eyes, and turned back to her. “The vest is great, Ben, and whatever you do with your hair is your own business. Anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well—there’s my nails. What do you think? Too Liberace?” Benny held out her hands for inspection. She’d been to an adventurous manicurist—glitter polish, red and black notes drawn on top of the enamel. Abby gave them a long, serious look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Amazing,” she said truthfully. Benny smiled. “What am I missing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Reeds?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("“Shit, I think they’re around here somewhere. What time is it?” Abby turned to search through stacks of magazines. Benny hip-bumped her aside ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("and slid bright purple sunglasses down her nose to look over the mess.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Time is an illusion of the working class,” she said, and fished a flat wooden reed case out from under a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("National Geographic")]), _vm._v(". She popped it open onehanded, like a cigarette case. “So you thrown up yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.” Abby took the case and closed it. The three reeds nestled on glass inside looked fine. “What am I missing?”’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sedatives? Ligature? Barf bag?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby ignored everything but the serious question. Ligature. “I picked the Bonade, it’s in the case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which mouthpiece?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Charles Bay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny tilted her head to one side, braids rustling like corn husks, and asked, “Why did you put socks on your dog?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re not socks. I’ll explain later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because if you’re going to put socks on him at least make them lime green or something. I mean, if I was a dog I wouldn’t want to run around in white athletic socks. It’s like wearing knee-highs with Bermuda shorts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re not socks, Benny, they’re bandages. Carlton ran away last night and tore up his feet. A guy brought him back this morning. Damn, where’s my music? Do you see my music?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn it, do you see my music?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Benny plucked it from where it was hiding under a chair and flipped through the pages like a punk ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("auditor. She nodded, slapped it shut, and tucked it under her arm.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“About this guy—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Later,” Abby said tightly. She swung the door wide and kneed Carlton back as he tried to limp outside. “Out. Out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny ambled casually out to the walkway, where she glittered like a chandelier in the harsh winter sun. Abby rubbed Carlton’s head for luck and locked the door behind her. She hefted the instrument case and frowned. She’d forgotten something, she was sure of it. Purse, keys, instrument, reeds, music—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Abby?” Benny puffed her cigarette, eyebrows cocked. “I’m not the fashion police or anything, but did you mean to wear the fuzzy slippers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby looked down, closed her eyes, and said, “It’s going to be one of those days, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s always one of those days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Midland was having a sunny winter, cold and clear and dry. Benny drove with the windows down on her beat-to-hell Gremlin, flicking ashes out into the air and admiring her nail polish. Abby watched the road—somebody had to—and concentrated on breathing. In. Out. In.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Truck,” she said. “Truck. Truck!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Benny looked up and twisted the wheel just enough to slide by. The salvage truck was big and half-rusted, squeaking on its springs; the faded letters on the side said, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("JESUS SAVES, WE RECYCLE")]), _vm._v(". The driver was a hunched old Hispanic man with a face that ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("looked eroded. He gave them a toothless smile as they passed.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t like my driving, get your own damn car out of the shop,” Benny grunted. “Uh-oh. Traffic jam.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were two cars at the light ahead, one late-model Ford pickup with smooth decolike styling, one decaying Mustang with a missing left quarter panel. The Mustang farted black smoke in a steady stream. Benny eased the Gremlin in behind the truck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, you live out here in the country, you’ll know the answer to this. Why do they bother to make pickup trucks aerodynamic?” she asked. She flicked the butt of her old cigarette out to the street. “And how come he has an empty gun rack? If you were going to be macho enough to have a gun rack, wouldn’t you put something in it? Was he cute?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cute?” Abby repeated blankly. “Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Him.” Benny waved her newly lit cigarette vaguely, leaving a ragged scarf of smoke. “You know. The guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, John Lee. Yeah, I suppose. In a cowboy kind of way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else is there out here? Intellectual professor types? Sensitive artists?” Benny rolled her eyes. “John "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lee?")]), _vm._v(" Not a guy with two first names.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, watch it, everybody out here has two first names except you and me.” Abby found herself smiling and didn’t know how it had happened. Benny had that effect on people. “John Lee Jordan.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Classy. But before you marry Joe Bob—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“John Lee.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("“—Bubba Lee … come to Dallas with me and meet some guys with real first names. Bob. Steve. Duncan.” Benny took a meditative drag on the cigarette and drummed fingernails on the steering wheel. “Duncan’s a babe. You’d like him.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What does he play?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny grinned. “Okay, guilty. Guitar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re kidding.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Classical guitar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The light changed. The pickup ahead of them cruised cautiously out into the intersection of Main and Parker. The hat brim of the driver moved right to left as he scanned the sides of the street. Benny hissed smoke and popped the clutch. The Gremlin vibrated uneasily as it picked up speed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Almost there. The Civic Auditorium was only four blocks away, a squat square building that looked like a prison except for the ample parking. Abby felt a spasm of dizziness and put her head back. Why did she do this? Why? Not for the adoration of her fans, that was for sure. If she was lucky, she’d have twenty-five people and most of them would be her clarinet students. Probably a few college kids from UT Permian Basin fulfilling recital credits. Maybe, if she was very lucky, a reporter from the local Midland paper would fit her in between garden and gun shows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny’s hand slid over hers and squeezed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ll do great,” she said with a sigh. “What gives with the program? I thought you said you were sick of doing the Concerto.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("“I am, but half my students will be playing it at a ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("region contest. And most of them don’t have any idea what it’s supposed to sound like.” Abby swallowed hard and closed her eyes. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not that I’m likely to show them how Mozart ought to sound")]), _vm._v(". “Did I tell you I’ve got one kid doing Debussy?”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“No kidding? Total bitch of a piano part. You got anybody decent for it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was kind of hoping you could give it a try.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny patted her hand. “Of course you were, you slut.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby opened her eyes as they pulled into the parking lot. The brakes squealed as Benny parked; she jerked the hand brake, killed the engine, and fished a pack of Marlboros from her blue satin jacket. She tapped one out and lit it, sucked smoke like most people sucked air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you were quitting,” Abby said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benny shrugged. She blew a wiggling halo of smoke, then another. They blew apart against the windshield.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I tried aerobics, but it wasn’t as much fun. You sick?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not yet,” Abby lied. She popped the door of the car and stepped out into the cold air, adjusting her long skirt around her. The world looked grainy and drab, the sky dust-orange. There were three other cars in the parking lot, and one of them was missing a tire. “I’ll go warm up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She collected her instruments and music. As she closed the door, Benny punched the radio buttons and found Black Sabbath. She wiggled in the seat, grinned, and blew another smoke ring.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("The world wasn’t drab. Benny was too bright for it.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The auditorium’s lobby felt chilly and dead when she entered, too cold and far too dark. There was an easel in the lobby with her picture on it—well, a glamorized approximation, anyway. Underneath, the sign said, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABIGAIL RHODES, MOZART CLARINET CONCERTO")]), _vm._v(". Underneath, in smaller letters, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BENINA WRIGHT, PIANO")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby’s stomach lurched. She darted for the bathroom and made it to one of the stalls in time, emptied her already empty stomach, and sat on her knees admiring the tan and orange tiles of the wall. The room smelled of Lysol and mildew. When she was sure it was over, she flushed the evidence and went to the sink to brush her teeth and gargle. Travel-sized toothbrush, toothpaste, Listerine. Like a Boy Scout, she came prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can do this,” she told her pallid reflection. Her blue eyes looked as faded as old denim. Gray strands in her black hair. She’d put on a few pounds in the last two years, not enough to bulge the dress but enough to soften the sharp bones of her face. She wasn’t sure she liked it. “You can do this. You know you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She knew. But knowing wasn’t enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She picked up her instrument case and headed backstage. The stage manager was messing with a light board and a roll of electrical tape; he jumped as if she’d caught him with a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Playboy")]), _vm._v(" and a towel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miss Rhodes, so nice to see you again. I’m looking forward to hearing you play. You know where the dressing room is—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("“I know, thanks, Paul.” She should. She’d been in ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("the theater hundreds of times in her high school years, had performed with the Midland Symphony at least thirty times since. She avoided the skeletal remains of a ladder and turned right down a narrow concrete hallway. The tap of her footsteps chased on ahead. The door of the women’s dressing room was propped open with a block of wood; she left it open and laid her instrument case on the makeup counter.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ritual. When panic shut down her brain, at least she had ritual. She took out the bottom half of the A clarinet and fitted it to the top half with a decisive twist of her wrist. The bell went on the bottom, the barrel on the top, the mouthpiece atop that. She took precise care in aligning her dampened best reed on the mouthpiece, checking from the back and front before screwing the slender silver ligature tight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ready. She put the instrument to her mouth and, all by themselves, muscles worked. Her diaphragm, pushing air. Her lips, falling naturally to a proper armature. Her fingers, finding the keys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The notes echoed from the walls, satiny-warm, round, alive. It was there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The music was there, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She played, eyes shut, listening as her body produced the music her soul heard, and her mind had nothing to do with it at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she opened her eyes some endless time later, she saw Benny standing quietly in the doorway, listening. Behind her shoulder, Paul the stage manager suddenly found someplace else to be. Benny’s sharp, angular face softened into a gentle smile, the blue eyes warm and fond.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("She only asked. “Ready?” but Abby could tell she already knew the answer, and before she could say it Benny turned and walked away, shoulders straight, braids swinging, down the hall toward the stage.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8418ec00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter01.vue
// module id = 84
// module chunks = 0